var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.612 20.648H23.25c2.234 0 3.373-1.117 3.373-3.33V6.071c0-2.213-1.139-3.319-3.373-3.319h-3.072c-.849 0-1.107-.172-1.59-.709l-.86-.967c-.537-.59-1.084-.913-2.19-.913H11.25c-1.106 0-1.654.322-2.191.913l-.86.967c-.483.526-.752.709-1.59.709H3.612C1.367 2.752.24 3.858.24 6.072v11.246c0 2.213 1.128 3.33 3.373 3.33Zm9.819-3.168a5.841 5.841 0 0 1-5.866-5.877 5.839 5.839 0 0 1 5.866-5.865 5.83 5.83 0 0 1 5.854 5.865 5.839 5.839 0 0 1-5.854 5.877Zm6.574-9.83c0-.73.644-1.375 1.396-1.375.742 0 1.375.645 1.375 1.375a1.4 1.4 0 0 1-1.375 1.386 1.398 1.398 0 0 1-1.396-1.386Zm-6.574 8.197a4.222 4.222 0 0 0 4.232-4.243 4.23 4.23 0 0 0-4.232-4.244 4.238 4.238 0 0 0-4.243 4.244 4.238 4.238 0 0 0 4.243 4.243Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.a5671bfb089fa201e51d0637bb44159c.svg";
export { ForwardRef as ReactComponent };